export const DOCUMENT_SLOTS = [
  { name: 'Experience letter', required: false },
  { name: 'Relieving letter', required: false },
  { name: 'Proof of age', required: false },
  { name: 'Education qualification certificates', required: false },
  { name: 'SSC', required: false },
  { name: 'HSC', required: false },
  { name: 'Graduation certificate', required: false },
  { name: 'Post graduation certificate', required: false },
  { name: 'Salary slip of previous employer', required: false },
  { name: 'NOC', required: false, candidateLabel: 'NOC (not mandate)' },
];
